/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileTxt: {
  name: 'file-txt';
  data: string;
} = {
  name: 'file-txt',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h4.586a1.5 1.5 0 0 1 1.06.44l3.415 3.414a1.5 1.5 0 0 1 .439 1.06V9a.5.5 0 0 1-1 0V5.5H10A1.5 1.5 0 0 1 8.5 4V1.5H4a.5.5 0 0 0-.5.5v7a.5.5 0 0 1-1 0V2Zm7 .207L11.793 4.5H10a.5.5 0 0 1-.5-.5V2.207Zm-6.45 9.157v.633h1.114V15h.76v-3.002h1.113v-.634H3.051Zm4.933 1.239-.733-1.24h-.872l1.117 1.819L6.357 15h.88l.746-1.241h.029L8.757 15h.885l-1.135-1.818 1.11-1.818h-.869l-.736 1.239h-.029Zm1.982-1.24v.635h1.113V15h.76v-3.002h1.113v-.634H9.965Z" fill="currentColor"/></svg>`,
};
